namespace Portico.Services.Legacy.EnrollmentService {
    import Api = Portico.Services.Legacy.EnrollmentService.Api;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;
    const apiModule = angular.module('app')
    .service('LegacyEnrollmentService.BasicEnrollmentApi', Api.BasicEnrollmentApi)
    .service('LegacyEnrollmentService.BasicEnrollmentWithPdfApi', Api.BasicEnrollmentWithPdfApi)
    .service('LegacyEnrollmentService.EnrollmentApi', Api.EnrollmentApi)
    .service('LegacyEnrollmentService.EnrollmentUpdateApi', Api.EnrollmentUpdateApi)
    .service('LegacyEnrollmentService.PatientSearchApi', Api.PatientSearchApi)
    .service('LegacyEnrollmentService.ResendCorrespondenceApi', Api.ResendCorrespondenceApi)
    .service('LegacyEnrollmentService.VerifySurveyAnswerApi', Api.VerifySurveyAnswerApi)

    export interface ILegacyEnrollmentService {
        BasicEnrollmentApi: Api.BasicEnrollmentApi;
        BasicEnrollmentWithPdfApi: Api.BasicEnrollmentWithPdfApi;
        EnrollmentApi: Api.EnrollmentApi;
        EnrollmentUpdateApi: Api.EnrollmentUpdateApi;
        PatientSearchApi: Api.PatientSearchApi;
        ResendCorrespondenceApi: Api.ResendCorrespondenceApi;
        VerifySurveyAnswerApi: Api.VerifySurveyAnswerApi;
    }

    @Service('app', 'LegacyEnrollmentService')
    @Inject(
    'LegacyEnrollmentService.BasicEnrollmentApi',
        'LegacyEnrollmentService.BasicEnrollmentWithPdfApi',
        'LegacyEnrollmentService.EnrollmentApi',
        'LegacyEnrollmentService.EnrollmentUpdateApi',
        'LegacyEnrollmentService.PatientSearchApi',
        'LegacyEnrollmentService.ResendCorrespondenceApi',
        'LegacyEnrollmentService.VerifySurveyAnswerApi',
    )
    export class LegacyEnrollmentService implements ILegacyEnrollmentService {
        constructor(
            public BasicEnrollmentApi: Api.BasicEnrollmentApi,
            public BasicEnrollmentWithPdfApi: Api.BasicEnrollmentWithPdfApi,
            public EnrollmentApi: Api.EnrollmentApi,
            public EnrollmentUpdateApi: Api.EnrollmentUpdateApi,
            public PatientSearchApi: Api.PatientSearchApi,
            public ResendCorrespondenceApi: Api.ResendCorrespondenceApi,
            public VerifySurveyAnswerApi: Api.VerifySurveyAnswerApi,
        ){}
    }     
}